import { useEffect } from 'react';

import { useCaptureException } from '@zenbusiness/application-commons-logging';

import { DASHBOARD_BOI, DASHBOARD } from '../constants/routes';

/**
 * Custom hook to handle redirection for authenticated users.
 *
 * @param {object} params - Parameters for the redirection logic.
 * @param {string} [params.businessEntityUuid] - Authenticated user's business entity uuid.
 * @param {string} params.redirectTo - The URL to redirect to.
 * @param {boolean} [params.shouldRedirect=true] - Whether to perform the redirection.
 */
export default function useAuthRedirectHandler({
  businessEntityUuid,
  redirectTo,
  shouldRedirect = true
}) {
  const captureException = useCaptureException();

  useEffect(() => {
    if (!shouldRedirect || !redirectTo) {
      return;
    }

    // Handle DASHBOARD_BOI redirection.
    if (redirectTo === DASHBOARD_BOI && !businessEntityUuid) {
      captureException('Business entity uuid not found for DASHBOARD_BOI redirect.', {
        level: 'info'
      });
      window.location.href = DASHBOARD;
      return;
    }

    window.location.href = redirectTo.replace('[businessEntityUuid]', businessEntityUuid ?? '');
  }, [businessEntityUuid, captureException, redirectTo, shouldRedirect]);
}
